import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/virtual-hairstyles"
    exact
    path="/business/showcase/virtual-hairstyles"
    component={AsyncPage}
  />,
];
